import React from 'react'

const CreateAgent = () => {
    return (
        <div>i am the Create</div>
    )
}

export default CreateAgent
